/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  PaymentCardsUserControllerFindManyQueryResponse,
  PaymentCardsUserControllerFindMany401,
} from '../types/PaymentCardsUserControllerFindMany.ts';

function getPaymentCardsUserFindManyUrl() {
  const res = { method: 'GET', url: `/api/user/payment-cards` as const };
  return res;
}

/**
 * @summary List own saved cards, including expired cards
 * {@link /api/user/payment-cards}
 */
export async function paymentCardsUserFindMany(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PaymentCardsUserControllerFindManyQueryResponse,
    ResponseErrorConfig<PaymentCardsUserControllerFindMany401>,
    unknown
  >({ method: 'GET', url: getPaymentCardsUserFindManyUrl().url.toString(), ...requestConfig });
  return res.data;
}
